import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7adb388e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "BuildingsList" }
const _hoisted_2 = { class: "BoxImage" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "BoxGap" }, null, -1))
const _hoisted_4 = { class: "Text" }
const _hoisted_5 = { class: "Title" }
const _hoisted_6 = {
  key: 0,
  class: "Caption"
}
const _hoisted_7 = { class: "Caption" }
const _hoisted_8 = { class: "Caption" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Image = _resolveComponent("Image")!
  const _component_OverviewBox = _resolveComponent("OverviewBox")!

  return (_openBlock(), _createBlock(_component_OverviewBox, {
    class: "BuildingsBox",
    link: {
      icon: 'buildings',
      to: 'BuildingsAndFloorPlans',
      title: _ctx.mixWB('VIEW_BUILDINGS_AND_FLOOR_PLANS'),
    }
  }, _createSlots({
    list: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.list, (item) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: item.id
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_Image, {
                image: item.getProfileImages()[0] ?? null,
                dimensions: { width: 80, height: 80 },
                transformation: 'square_80'
              }, null, 8, ["image"])
            ]),
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(item.getTitle()), 1),
              (item.getBuildingTypeCodeText())
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(item.getBuildingTypeCodeText()), 1))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_7, _toDisplayString(this.mixWB('YEAR_OF_CONSTRUCTION')) + ": " + _toDisplayString(item.getYearBuilt() ?? '-'), 1),
              _createElementVNode("span", _hoisted_8, _toDisplayString(this.mixWB('BUILT_UP_AREA')) + ": " + _toDisplayString(item.getBuiltArea() ?? '-'), 1)
            ])
          ], 64))
        }), 128))
      ])
    ]),
    _: 2
  }, [
    (!_ctx.data.list.length)
      ? {
          name: "noData",
          fn: _withCtx(() => [
            _createElementVNode("p", null, _toDisplayString(_ctx.mixWB('NO_UNITS_SELECTED_YET')), 1)
          ])
        }
      : undefined,
    (_ctx.data.meta)
      ? {
          name: "meta",
          fn: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.data.meta), 1)
          ])
        }
      : undefined,
    (_ctx.data.list.length >= 3)
      ? {
          name: "subHeader",
          fn: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.mixWB('THE_X_FIRST_BUILDINGS', ['3'])), 1)
          ])
        }
      : undefined
  ]), 1032, ["link"]))
}